export default __webpack_public_path__ + "static/media/layers-fill.156ac707.svg";